import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
} 


// typeof window — הקובץ נטען גם ברינדור הסטטי בזמן build (Node, בלי window)
export const isIframe = typeof window !== "undefined" && window.self !== window.top;
